<div class="info-box" [class]="getColorStatus()">
    <mat-accordion class="info-box__accordion">
        <mat-expansion-panel
            class="info-box__panel"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [hideToggle]="!infoBox.infoboksBeskrivelse"
            [attr.aria-expanded]="panelOpenState"
            role="region"
            [attr.aria-labelledby]="'panel-header-information'"
        >
            <mat-expansion-panel-header
                id="panel-header-information"
                class="info-box__header"
                [class]="!infoBox.infoboksBeskrivelse ? 'disabled' : ''"
                [title]="panelOpenState ? 'Luk' + ' besked beskrivelse for ' + infoBox.infoboksOverskrift : 'Åben' + ' besked beskrivelse for ' + infoBox.infoboksOverskrift"
                role="button"
                [attr.aria-controls]="'panel-content-description'"
                [attr.aria-expanded]="panelOpenState"
                [attr.aria-disabled]="!infoBox.infoboksBeskrivelse"
            >
                <mat-panel-title class="info-box__title">
                    <title>Informations ikon</title>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 19 19" fill="none" class="info-box__icon" role="img" aria-label="Information ikon">
                        <path
                            d="M8.25 14.3477V8.84766H10.0977V14.3477H8.25ZM2.66406 3.30469C4.46875 1.5 6.63151 0.597656 9.15234 0.597656C11.7018 0.597656 13.8646 1.5 15.6406 3.30469C17.4453 5.08073 18.3477 7.22917 18.3477 9.75C18.3477 12.2708 17.4453 14.4336 15.6406 16.2383C13.8646 18.0143 11.7018 18.9023 9.15234 18.9023C6.63151 18.9023 4.46875 18.0143 2.66406 16.2383C0.888021 14.4336 0 12.2708 0 9.75C0 7.22917 0.888021 5.08073 2.66406 3.30469ZM3.99609 14.9492C5.42839 16.3815 7.14714 17.0977 9.15234 17.0977C11.1862 17.0977 12.9193 16.3815 14.3516 14.9492C15.7839 13.5169 16.5 11.7839 16.5 9.75C16.5 7.71615 15.7839 5.98307 14.3516 4.55078C12.9193 3.11849 11.1862 2.40234 9.15234 2.40234C7.14714 2.40234 5.42839 3.11849 3.99609 4.55078C2.5638 5.98307 1.84766 7.71615 1.84766 9.75C1.84766 11.7839 2.5638 13.5169 3.99609 14.9492ZM8.25 7V5.15234H10.0977V7H8.25Z"
                        />
                    </svg>
                    @if (infoBox.infoboksOverskrift) {
                    <h2>
                        {{ infoBox.infoboksOverskrift }}
                    </h2>
                    }
                </mat-panel-title>

                @if (infoBox.infoboksBeskrivelse.length) {
                <mat-panel-description class="info-box__description">
                    {{ panelOpenState ? "Luk" : "Vis" }}
                </mat-panel-description>
                }
            </mat-expansion-panel-header>

            @if (infoBox.infoboksBeskrivelse.length) {
            <div
                id="panel-content-description"
                class="info-box__text"
                [innerHTML]="infoBox.infoboksBeskrivelse"
                [attr.aria-hidden]="!panelOpenState"
                [attr.aria-expanded]="panelOpenState"
                role="region"
            ></div>
            }
        </mat-expansion-panel>
    </mat-accordion>
</div>
